import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    keyword: "",
    status: "All",
    daysTab: "today",
    startDate: "",
    endDate: "",
    clickRow:""
}

const invoicesSlice = createSlice({
    name: "invoices",
    initialState,
    reducers: {
        setKeyword: (state, action) => {
            state.keyword = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload;
        },
        setEndDate: (state, action) => {
            state.endDate = action.payload;
        },
        setDaysTab: (state, action) => {
            state.daysTab = action.payload;
        },
        setClickRow: (state, action) => {
            state.clickRow = action.payload;
        },
        resetAllFilters: (state) => {
            state.keyword = initialState.keyword;
            state.status = initialState.status;
            state.startDate = initialState.startDate;
            state.endDate = initialState.endDate;
            state.daysTab = initialState.daysTab;
        }
    }

});

export const {
    setKeyword,
    setStatus,
    setStartDate,
    setEndDate,
    setDaysTab,
    setClickRow,
    resetAllFilters,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;